<template>
  <div class="flex items-center space-x-1">
    <div>
    <span class="text-darkBlue tracking-wide  font-semibold"
    >{{ message.userDisplay }}
    </span>
    </div>
    <div v-if="vectricAuthor">
      <svg xmlns="http://www.w3.org/2000/svg"
           class="h-4 w-4 text-vcarvePro fill-current"
           viewBox="0 0 256 256">
        <path
            d="M243.28,68.24l-24-23.56a16,16,0,0,0-22.58,0L104,136h0l-.11-.11L67.25,100.62a16,16,0,0,0-22.57.06l-24,24a16,16,0,0,0,0,22.61l71.62,72a16,16,0,0,0,22.63,0L243.33,90.91A16,16,0,0,0,243.28,68.24ZM103.62,208,32,136l24-24,.11.11,36.64,35.27a16,16,0,0,0,22.52,0L208.06,56,232,79.6Z"></path>
      </svg>
    </div>
<!--    <span class="hidden md:block"> on {{ postDate }} </span>-->
  </div>
</template>

<script>
export default {
  name: "TopicAuthor",
  props: {
    message: {}
  },
  computed: {
    postDate() {
      if (this.message.timestamp) {
        return this.message.timestamp.toDate().toLocaleString();
      }
      return "";
    },
    vectricAuthor() {
      return this.message.isVectric === true;
    }
  }
};
</script>

<style scoped></style>
